import React, { useEffect, useState } from "react";
import { AppState, useAppSelector } from "../RootReducer";
import { SportsbookProvider } from "../http/protocol";
import MetaHelmet from "../utils/MetaHelmet";
import { isEmpty } from "../user/ui/utils";
import { getSEOData, renderSportsComponent } from "./Sportsbook";
import Root from "../layout/Root";
import { Link, Route, Switch, useHistory, useLocation, useRouteMatch } from "react-router-dom";
import DynamicContentView from "../landingpage/pagesection/DynamicContentView";
import { fetchAndParseContent } from "../contenful/ContentfulActions";
import { useDispatch } from "react-redux";
import { ContentModelName } from "../contenful/types";
import { getContainer } from "../ioc/IOCSetup";

export default function SportsbooksProvider() {
  const location = useLocation();
  const settings = useAppSelector((app: AppState) => app.settings.settings);
  const [provider, setProvider] = useState<SportsbookProvider | undefined>(undefined);
  const sportPageContent = useAppSelector((app: AppState) => app.contentful.sportsPage);
  const userLoaded = useAppSelector((app: AppState) => app.user.userInfoLoaded);
  const loggedIn = useAppSelector((app: AppState) => app.user.user?.loggedIn);
  const [freshChatLoaded, setfreshChatLoaded] = useState<boolean>(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!sportPageContent) {
      dispatch(fetchAndParseContent(ContentModelName.SPORTSPAGE, getContainer().getSettingsService().getActiveLocale().code) as any);
    }
  }, [dispatch, sportPageContent]);

  useEffect(() => {
    if (settings && settings.sportsbookConfig && settings.sportsbookConfig.enabledConfig) {
      settings.sportsbookConfig.providers?.forEach((c) => {
        if (location.pathname.includes(c.pathname ?? "")) {
          setProvider(c.provider);
        }
      });
    }

    return () => {
      setProvider(undefined);
    };
  }, [location.pathname, settings]);

  useEffect(() => {
    let fcWidget = window.fcWidget;
    if (fcWidget && fcWidget.isLoaded() && !freshChatLoaded) {
      if (fcWidget) {
        if (provider === SportsbookProvider.ULTRAPLAY) {
          fcWidget.setConfig({ headerProperty: { direction: "ltr" } });
        }
      }
      setfreshChatLoaded(true);
    }

    return () => {
      if (fcWidget) {
        fcWidget.setConfig({ headerProperty: { direction: "rtl" } });
      }
      setfreshChatLoaded(false);
    };
  }, []);

  const { seoTitle, title, seoDescription, description, keywords, seoImageURL, locale } = getSEOData(settings, sportPageContent);
  return (
    <Root footer={true}>
      <Switch>
        <Route path="/sportsbook/:provider"><MetaHelmet title={!isEmpty(seoTitle) ? seoTitle : title} description={!isEmpty(seoDescription) ? seoDescription : description} keywords={keywords} ogTitle={seoTitle} ogDescription={seoDescription} ogImage={seoImageURL} lang={locale} /></Route>
      </Switch>
      {renderSportsComponent(provider, location, userLoaded)}
      {sportPageContent && <DynamicContentView dynamicContent={sportPageContent.dynamicContent} loggedIn={loggedIn} />}
    </Root>
  );
}
